
import {
  reliability,
  solutions,
  popularServices,
  questions,
} from "~/data/infrastructureServices";
import Modal from "~/components/rebranding/modal/Modal.vue";

export default {
  data() {
    return {
      activeSection: "",
      FormTitle: "",
      reliability,
      solutions,
      popularServices,
      questions,
      quickSections: [
        { id: "solutions", label: "زیرساخت اختصاصی" },
        { id: "reliability", label: "سادگی و اطمینان" },
        { id: "colocation", label: "انعطاف‌پذیری و یکپارچگی" },
        { id: "support", label: "تماس با متخصصان" },
        { id: "dedicatedServer", label: "دسترس‌پذیری تضمین‌شده" },
        { id: "popular-services", label: "خدمات پرکاربرد" },
        { id: "faq", label: "سوالات متداول" },
      ],
    };
  },
  components: {
    Modal,
  },
  methods: {
    handleScroll(e) {
      if (document.documentElement.scrollTop > 550) {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center floating";
      } else {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center";
      }
    },
  },
  beforeMount() {
    if (window.innerWidth >= 960)
      window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    if (window.innerWidth >= 960)
      window.removeEventListener("scroll", this.handleScroll);
  },
  head() {
    return {
      title: "خدمات زیرساخت اختصاصی آبالون | ابر خصوصی، ابر ایزوله و کوبرنتیز",
      meta: [
        {
          name: "description",
          content:
            "خدمات زیرساخت اختصاصی آبالون | ابر خصوصی، ابر ایزوله و کوبرنتیز سازمانی | امنیت، کنترل و مقیاس‌پذیری برای زیرساخت‌های سازمانی بدون پیچیدگی",
        },
        {
          name: "keywords",
          content:
            "خدمات زیرساخت اختصاصی آبالون, کوبرنتیز, ابر اختصاصی, ابر ایزوله",
        },
        {
          property: "og:url",
          content: "https://abalon.cloud/infrastructure-services",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:locale",
          content: "fa",
        },
        {
          property: "og:title",
          content:
            "خدمات زیرساخت اختصاصی آبالون | ابر خصوصی، ابر ایزوله و کوبرنتیز",
        },
        {
          property: "og:description",
          content:
            "خدمات زیرساخت اختصاصی آبالون | ابر خصوصی، ابر ایزوله و کوبرنتیز سازمانی | امنیت، کنترل و مقیاس‌پذیری برای زیرساخت‌های سازمانی بدون پیچیدگی",
        },
        {
          property: "og:image",
          content: "/images/og-image.png",
        },
        {
          property: "og:logo",
          content: "/images/logo.svg",
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:url",
          content: "https://abalon.cloud/infrastructure-services",
        },
        {
          name: "twitter:title",
          title:
            "خدمات زیرساخت اختصاصی آبالون | ابر خصوصی، ابر ایزوله و کوبرنتیز",
        },
        {
          name: "twitter:description",
          content:
            "خدمات زیرساخت اختصاصی آبالون | ابر خصوصی، ابر ایزوله و کوبرنتیز سازمانی | امنیت، کنترل و مقیاس‌پذیری برای زیرساخت‌های سازمانی بدون پیچیدگی",
        },
        {
          name: "format-detection",
          content: "telephone=no",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://abalon.cloud/infrastructure-services",
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "خدمات زیرساخت اختصاصی آبالون شامل چه سرویس‌هایی می‌شوند؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "خدمات زیرساخت اختصاصی آبالون شامل سه سرویس کلیدی است: ابر خصوصی برای مهاجرت امن و اختصاصی به محیط ابری، ابر ایزوله برای ارتباط پایدار بر بستر شبکه نورونتا، و کوبرنتیز مدیریت‌شده برای اجرای اپلیکیشن‌های کانتینری با پایداری بالا.",
                },
              },
              {
                "@type": "Question",
                name: "تفاوت ابر خصوصی و ابر ایزوله آبالون چیست؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "ابر خصوصی محیطی اختصاصی درون سازمان فراهم می‌کند که کنترل کامل و امنیت داده‌ها را تضمین می‌کند، در حالی که ابر ایزوله بر بستر شبکه نورونتا ارائه می‌شود و تمرکز آن بر ایجاد ارتباط ایمن با دیتاسنترهای آبالون بدون وابستگی به اینترنت عمومی است.",
                },
              },
              {
                "@type": "Question",
                name: "مزیت اصلی خدمات زیرساخت اختصاصی آبالون نسبت به سرویس‌های عمومی ابری چیست؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "مزیت اصلی این خدمات تمرکز بر امنیت، کنترل کامل و انطباق با الزامات امنیتی سازمان‌ها است. زیرساخت اختصاصی آبالون امکان استقرار سفارشی، ارتباط ایزوله از اینترنت و مدیریت تخصصی زیرساخت را فراهم می‌کند.",
                },
              },
              {
                "@type": "Question",
                name: "چه سازمان‌هایی بیشترین بهره را از خدمات زیرساخت اختصاصی آبالون می‌برند؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "سازمان‌ها و نهادهای دولتی با داده‌های حساس یا محرمانه، شرکت‌هایی با شعب متعدد یا پراکندگی جغرافیایی بالا، و کسب‌وکارهایی که به پایداری و دسترس‌پذیری مداوم نیاز دارند، بیشترین بهره را از خدمات زیرساخت اختصاصی آبالون می‌برند.",
                },
              },
            ],
          },
        },
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org/",
            "@type": "Review",
            itemReviewed: {
              "@type": "CreativeWorkSeries",
              name: "خدمات زیرساخت اختصاصی آبالون",
            },
            author: {
              "@type": "Person",
              name: "Amirhosein",
            },
            reviewRating: {
              "@type": "Rating",
              ratingValue: "4.9",
              bestRating: "5",
            },
            publisher: {
              "@type": "Organization",
              name: "Abalon Cloud Solutions",
            },
          },
        },
      ],
    };
  },
};
